import brand from 'brands/sams'

export default brand
export const { clientInfo } = brand
export const { palette } = brand
export const brandImages = brand.images
